// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-menu {
  float: right;
  border-radius: 100%;
  width: 40px;
  height: 40px;
}

.close-menu-collapsed {
  float: none;
  margin-left: 5px;
}

.icon-large {
  font-size: 20px;
}

.sidebar-collapsed {
  max-width: 60px;
}

.pull-right {
  float: right;
}

.small-text {
  font-size: 12px;
}

.card-inline {
  display: inline-block;
}

.custom-chart-container {
  min-height: 530px;
}

.profile-photo {
  width: 300px;
  height: 300px;
  border-radius: 50%;
}

.profile-photo-report {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.site-photo {
  max-width: 400px;
}

.cover-photo {
  max-width: 400px;
}

.review-photo {
  width: 100px;
  height: 100px;
  border-radius: 50%;
}

.review-photo-small {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.person-name {
  text-decoration: none;
  color: var(--bs-heading-color);
}

.picker {
  width: 600px;
  background: #f0f0f4;
  border-radius: 9px;
}

.picker .react-colorful {
  width: auto;
}

.picker-swatches {
  display: flex;
  padding: 12px;
  flex-wrap: wrap;
}

.picker-swatch {
  width: 24px;
  height: 24px;
  margin: 4px;
  border: none;
  padding: 0;
  border-radius: 4px;
  cursor: pointer;
  outline: none;
}

.picker-swatch-active {
  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.5);
}

#sidebarMenu i {
  font-size: 18px;
}

.react-date-picker__wrapper {
  border: none !important;
}

.main-color {
  background-color: #520702 !important;
}

.white-text {
  color: #fff !important;
}
`, "",{"version":3,"sources":["webpack://./frontend_admin/app.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,aAAa;AACf;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":[".close-menu {\n  float: right;\n  border-radius: 100%;\n  width: 40px;\n  height: 40px;\n}\n\n.close-menu-collapsed {\n  float: none;\n  margin-left: 5px;\n}\n\n.icon-large {\n  font-size: 20px;\n}\n\n.sidebar-collapsed {\n  max-width: 60px;\n}\n\n.pull-right {\n  float: right;\n}\n\n.small-text {\n  font-size: 12px;\n}\n\n.card-inline {\n  display: inline-block;\n}\n\n.custom-chart-container {\n  min-height: 530px;\n}\n\n.profile-photo {\n  width: 300px;\n  height: 300px;\n  border-radius: 50%;\n}\n\n.profile-photo-report {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n\n.site-photo {\n  max-width: 400px;\n}\n\n.cover-photo {\n  max-width: 400px;\n}\n\n.review-photo {\n  width: 100px;\n  height: 100px;\n  border-radius: 50%;\n}\n\n.review-photo-small {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n\n.person-name {\n  text-decoration: none;\n  color: var(--bs-heading-color);\n}\n\n.picker {\n  width: 600px;\n  background: #f0f0f4;\n  border-radius: 9px;\n}\n\n.picker .react-colorful {\n  width: auto;\n}\n\n.picker-swatches {\n  display: flex;\n  padding: 12px;\n  flex-wrap: wrap;\n}\n\n.picker-swatch {\n  width: 24px;\n  height: 24px;\n  margin: 4px;\n  border: none;\n  padding: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  outline: none;\n}\n\n.picker-swatch-active {\n  box-shadow: 0 0 0 5px rgba(0, 0, 0, 0.5);\n}\n\n#sidebarMenu i {\n  font-size: 18px;\n}\n\n.react-date-picker__wrapper {\n  border: none !important;\n}\n\n.main-color {\n  background-color: #520702 !important;\n}\n\n.white-text {\n  color: #fff !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
